import React from 'react';
import styled from 'styled-components';
import { Card, CardHeader } from './Card';

interface ChartCardProps {
  title?: React.ReactNode;
  subtitle?: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
  variant?: 'card' | 'section';
  titleVariant?: 'default' | 'section';
  surface?: 'default' | 'white';
}

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  meta,
  children,
  variant = 'card',
  titleVariant = 'default',
  surface = 'default'
}) => {
  const CardSurface = surface === 'white' ? WhiteCard : Card;
  if (variant === 'section') {
    return (
      <SectionWrap>
        {(title != null || subtitle != null || meta != null) && (
          <CardHeader
            title={title ?? ''}
            subtitle={subtitle}
            meta={meta}
            titleVariant={titleVariant}
          />
        )}
        <ChartContent>{children}</ChartContent>
      </SectionWrap>
    );
  }

  return (
    <CardSurface>
      <CardHeader
        title={title ?? ''}
        subtitle={subtitle}
        meta={meta}
        titleVariant={titleVariant}
      />
      <ChartContent>{children}</ChartContent>
    </CardSurface>
  );
};

const WhiteCard = styled(Card)`
  background: #fff;
`;

const SectionWrap = styled.section`
  border-top: 1px solid var(--line-soft, #e8e5df);
`;

const ChartContent = styled.div`
  padding: 0 20px 20px;
`;
